import { ERP_RETRY_API_URL } from "../components/Shared/constant";

const ErpRetryAPI = async (payload, accessToken) => {
    const responce = window.axios.post(ERP_RETRY_API_URL, payload, {
    headers: {
      'Authorization': 'Bearer ' + accessToken,
    }}).then(function (result) {
        return {
          ...result.data,
          status:200
        };
    }).catch(function (result) {
        return {
          ...result?.response?.data,
          status:result?.response?.status
        }
    });
    return responce;
};
  
export default ErpRetryAPI;